// import envConst from '../../const'
import axios from '../../plugins/axios'
import store from '../../store/'
export default function (wser) {
  // console.log(store.state.userType);
  return new Promise((resolve, reject) => {
    let wsPath = ''
    let reqs
    console.log(wser, wsPath)

    // 启动ws
    // wser.onmessage = function (data) {
    //   store.commit('setNotifyData', data)
    // }
    // wser.onclose = function () {
    //   store.commit('setNotifyData', null)
    // }
    // wser.open(
    //   `${envConst.API_ORIGIN}${wsPath}?Authorization=${localStorage.token}`
    // )

    // 平台
    wsPath = '/notify/boss'
    reqs = [
      axios.get('/region/provinces'),
      axios.get('/sys/role/options'),
      axios.get('/sys/user/types'),
      axios.get('/mall/supplier/options'),
      axios.get('/tenant/options'),
      axios.get('/decorate/company/options'),
      axios.get('/construction/marital/selection/unit'),//材料表单位
      axios.get('/construction/marital/selection/supplys'),//材料表供货方式
    ]
    axios
      .all(reqs)
      .then(
        axios.spread(
          (provinces, roleList, userTypes, suppliers, brands, companies, units, supplys,) => {
            store.commit('setProvinces', provinces)
            store.commit('setUserTypes', { scope: 'admin', value: userTypes })
            store.commit('setRoles', roleList)
            store.commit('setUnread')
            store.commit('setSelectOptions', {
              label: 'suppliers',
              value: suppliers.map(item => {
                return {
                  label: item.value,
                  value: item.key
                }
              })
            })
            store.commit('setSelectOptions', {
              label: 'brands',
              value: brands.map(item => {
                return {
                  label: item.value,
                  value: item.key
                }
              })
            })
            store.commit('setSelectOptions', {
              label: 'companies',
              value: companies.map(item => {
                return {
                  label: item.value,
                  value: item.key
                }
              })
            })
            store.commit('setSelectOptions', {
              label: 'units',
              value: units.map((item) => {
                return {
                  label: item.value,
                  value: item.key,
                }
              }),
            })
            store.commit('setSelectOptions', {
              label: 'supplys',
              value: supplys.map((item) => {
                return {
                  label: item.value,
                  value: item.key,
                }
              }),
            })
            resolve()
          }
        )
      )
      .catch(reject)
  })
}
